import ReactTable from "common/components/ReactTable/ReactTable";
import React, { useEffect, useState } from "react";
import { useGetVolunteersSummaryQuery } from "features/api/reports/reportsSlice";
import { getVolunteerTableColumns } from "../utils";
import Header from "../Components/Header";
import { FilterFields } from "../Components/types";

const VolunteerReport = () => {
  const [filterValues, setFilterValues] = useState<FilterFields[]>([]);
  const [pageIndex, setPageIndex] = useState(1);
  const [pageCount, setPageCount] = useState(0);
  const [data, setData] = useState([]);
  const excelEndpoint = `GetVolunteersSummaryAsExcelFile`;

  const dateFiltersKeys = ["lastReportDate", "appUpdateDate", "downloadTime"];

  const submitFilter = (filters: FilterFields[]) => {
    setFilterValues(filters);
  };

  const filterObject = filterValues.reduce((acc, cur) => {
    return {
      ...acc,
      [cur.field]: dateFiltersKeys.includes(cur.field)
        ? `${cur.startDate}-${cur.endDate}`
        : cur.value,
    };
  }, {});

  const {
    data: volunteerData,
    isFetching,
    error,
  } = useGetVolunteersSummaryQuery({
    page: pageIndex,
    filter: filterObject,
  });

  useEffect(() => {
    if (!isFetching && volunteerData) {
      setData(volunteerData.objectList || []);
      setPageCount(volunteerData.totalPages || 0);
    }
  }, [volunteerData, isFetching, error]);

  const columns = getVolunteerTableColumns;

  return (
    <div style={{ paddingBottom: 20 }}>
      <Header
        columns={columns.filter((col) => col.accessor !== "currentVersion")}
        submitFilter={submitFilter}
        filterValues={filterValues}
        thereIsData={data?.length > 0}
        excelEndpoint={excelEndpoint}
      />
      <ReactTable
        data={data}
        columns={columns}
        pageIndex={pageIndex}
        setPageIndex={setPageIndex}
        pageCount={pageCount}
      />
    </div>
  );
};

export default VolunteerReport;
